export default {
  "头图":{
    "头像登录":{"f_module":"头图","f_resource":"头像登录","f_type":4},
    "活动规则":{"f_module":"头图","f_resource":"活动规则","f_type":4},
  },
  "领蛋模块":{
    "找老铁碰个蛋":{"f_module":"领蛋模块","f_resource":"找老铁碰个蛋","f_type":4},
    "去yoo镀金":{"f_module":"领蛋模块","f_resource":"去yoo镀金","f_type":4},
    "提现":{"f_module":"领蛋模块","f_resource":"提现","f_type":4}
  },
  "招商专场":{
    "跳转按钮":{"f_module":"招商专场","f_resource":"跳转按钮","f_type":4}
  },
  "专场蛋": {
    "预约所有专场":{"f_module":"专场蛋","f_resource":"预约所有专场","f_type":4}
  },
  "抢钱攻略":{
    "找老铁碰个蛋":{"f_module":"抢钱攻略","f_resource":"找老铁碰个蛋","f_type":4},
    "开VIP加蛋":{"f_module":"抢钱攻略","f_resource":"开VIP加蛋","f_type":4},
    "去yoo镀金":{"f_module":"抢钱攻略","f_resource":"去yoo镀金","f_type":4},
    "开VIP":{"f_module":"抢钱攻略","f_resource":"开VIP","f_type":4},
    "查看详细攻略":{"f_module":"抢钱攻略","f_resource":"查看详细攻略","f_type":4},
  },
  "明星碰蛋":{
    "明星视频":{"f_module":"明星碰蛋","f_resource":"明星视频","f_type":4},
  },
  "碰蛋记录":{
    "碰蛋战绩tab":{"f_module":"碰蛋记录","f_resource":"碰蛋战绩tab","f_type":4},
    "获蛋记录":{"f_module":"碰蛋记录","f_resource":"获蛋记录","f_type":4},
    "查看我的奖品":{"f_module":"碰蛋记录","f_resource":"查看我的奖品","f_type":4},
    "去yoo提现":{"f_module":"碰蛋记录","f_resource":"去yoo提现","f_type":4},
    "提现":{"f_module":"碰蛋记录","f_resource":"提现","f_type":4},
  },
  "新春蛋皇":{
    "填写获奖信息":{"f_module":"新春蛋皇","f_resource":"填写获奖信息","f_type":4},
    "查看锦鲤":{"f_module":"新春蛋皇","f_resource":"查看锦鲤","f_type":4},
    "锦鲤弹框-知道了":{"f_module":"新春蛋皇","f_resource":"锦鲤弹框-知道了","f_type":4},
  },
  "好友碰蛋":{
    "头像点击":{"f_module":"好友碰蛋","f_resource":"头像点击","f_type":4},
    "邀请好友":{"f_module":"好友碰蛋","f_resource":"邀请好友","f_type":4},
    "换一换":{"f_module":"好友碰蛋","f_resource":"换一换","f_type":4},
  },
  "跑马灯":{
    "模块曝光":{"f_module":"跑马灯","f_resource":"模块曝光","f_type":4},
  },
  "攻略弹框":{
    "立即参与对对碰":{"f_module":"攻略弹框","f_resource":"立即参与对对碰","f_type":4},
  },
  "邀请好友碰蛋浮层":{
    "以后再说":{"f_module":"邀请好友碰蛋浮层","f_resource":"以后再说","f_type":4},
    "直接转发图片":{"f_module":"邀请好友碰蛋浮层","f_resource":"直接转发图片","f_type":4},
  },
  "奖品浮层":{
    "主客态奖品浮层曝光":function(){
      let data = {"f_module":"奖品浮层","f_type":2}
      let args = arguments
      let f_resourceArr = ["","奖品浮层曝光"]
      data.f_resource = ''
      for(let i = 0;i<f_resourceArr.length;i++){
        data.f_resource += f_resourceArr[i]
        if(i<f_resourceArr.length-1){
          data.f_resource += args[i]
        }
      }
      return data
    },
    "继续碰蛋":{"f_module":"奖品浮层","f_resource":"继续碰蛋","f_type":4},
    "我再试试":{"f_module":"奖品浮层","f_resource":"我再试试","f_type":4},
    "炫耀一下":{"f_module":"奖品浮层","f_resource":"炫耀一下","f_type":4},
    "我的资产":{"f_module":"奖品浮层","f_resource":"我的资产","f_type":4},
    "左箭头":{"f_module":"奖品浮层","f_resource":"左箭头","f_type":4},
    "右箭头":{"f_module":"奖品浮层","f_resource":"右箭头","f_type":4},
    "去yoo提现":{"f_module":"奖品浮层","f_resource":"去yoo提现","f_type":4},
  },
  "炫耀浮层":{
    "以后再说":{"f_module":"炫耀浮层","f_resource":"以后再说","f_type":4},
  },
  "碰蛋浮层":{
    "不想碰":{"f_module":"碰蛋浮层","f_resource":"不想碰","f_type":4},
    "和TA碰":{"f_module":"碰蛋浮层","f_resource":"和TA碰","f_type":4},
    "算了":{"f_module":"碰蛋浮层","f_resource":"算了","f_type":4},
    "查看我的福蛋":{"f_module":"碰蛋浮层","f_resource":"查看我的福蛋","f_type":4},
    "续VIP获彩蛋":{"f_module":"碰蛋浮层","f_resource":"续VIP获彩蛋","f_type":4},
  },
}